
import { qs } from './dom.js'
import { TimelineMax, TweenMax, Power2 } from 'gsap/TweenMax'

export default class Loader {
  constructor () {
    this.loaded = false
    this.loader = qs('.loader')
    this.bg = qs('.loader__bg', this.loader)
    this.logo = qs('.loader__logo', this.loader)
    this.ctx = this.bg.getContext('2d')
    this.init = true
    this.isHiding = false
    this.render = this.render.bind(this)
    this.resize = this.resize.bind(this)
    this.resize()
    this.initTimelineBgIn()
  }

  render () {
    // console.log(this.ctx.canvas)
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)
    this.ctx.beginPath()
    this.ctx.moveTo(this.bgPointsBack[0].x, this.bgPointsBack[0].y)

    this.ctx.quadraticCurveTo(this.bgPointsBack[1].x, this.bgPointsBack[1].y,
      this.bgPointsBack[2].x, this.bgPointsBack[2].y)

    this.ctx.lineTo(this.bgPointsBack[3].x, this.bgPointsBack[3].y)

    this.ctx.quadraticCurveTo(this.bgPointsBack[4].x, this.bgPointsBack[4].y,
      this.bgPointsBack[5].x, this.bgPointsBack[5].y)

    this.ctx.closePath()
    this.ctx.fillStyle = '#085aae' // '#81dcdd'
    this.ctx.fill()
    this.ctx.beginPath()
    this.ctx.moveTo(this.bgPoints[0].x, this.bgPoints[0].y)

    this.ctx.quadraticCurveTo(this.bgPoints[1].x, this.bgPoints[1].y,
      this.bgPoints[2].x, this.bgPoints[2].y)

    this.ctx.lineTo(this.bgPoints[3].x, this.bgPoints[3].y)

    this.ctx.quadraticCurveTo(this.bgPoints[4].x, this.bgPoints[4].y,
      this.bgPoints[5].x, this.bgPoints[5].y)

    this.ctx.closePath()
    this.ctx.fillStyle = '#ffffff'
    this.ctx.fill()
  }

  resize () {
    const w = document.documentElement.clientWidth
    const h = document.documentElement.clientHeight

    this.bg.width = w
    this.bg.height = h
    this.bgPoints = [{
      x: 0,
      y: 0
    }, {
      x: w / 2,
      y: 0
    }, {
      x: w,
      y: 0
    }, {
      x: w,
      y: 0
    }, {
      x: w / 2,
      y: 0
    }, {
      x: 0,
      y: 0
    }]
    this.bgPointsBack = [{
      x: 0,
      y: 0
    }, {
      x: w / 2,
      y: 0
    }, {
      x: w,
      y: 0
    }, {
      x: w,
      y: 0
    }, {
      x: w / 2,
      y: 0
    }, {
      x: 0,
      y: 0
    }]

    if (this.tlBgIn) {
      this.tlBgIn.kill()
      this.initTimelineBgIn()
      this.tlBgIn.progress(0, false)
    }

    this.render()
  }

  initTimelineBgIn () {
    const self = this

    this.tlBgIn = new TimelineMax({
      paused: true,
      onUpdate: this.render,
      onComplete: () => {
        self.isHiding = false
      }
    })

    this.tlBgIn.to(this.bgPointsBack[4], 0.65, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, 'in')

    this.tlBgIn.to([this.bgPointsBack[3], this.bgPointsBack[5]], 0.65, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.61').to(this.bgPoints[4], 0.65, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.61').to([this.bgPoints[3], this.bgPoints[5]], 0.65, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.61').addPause()

    this.tlBgIn.to(this.bgPoints[1], 0.6, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, 'out')

    this.tlBgIn.to([this.bgPoints[0], this.bgPoints[2]], 0.6, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.56').to(this.bgPointsBack[1], 0.6, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.56').to([this.bgPointsBack[0], this.bgPointsBack[2]], 0.6, {
      y: this.bg.height,
      ease: Power2.easeInOut
    }, '-=0.56').progress(0.5, false)
  }

  display () {
    this.loader.classList.add('loader--init')
    this.logo.classList.add('loader__logo--playing')
    if (this.init) {
      this.init = false
      return
    }

    this.tlBgIn.play('in')
  }

  hide () {
    this.isHiding = true
    this.loader.classList.remove('loader--init')
    this.logo.classList.remove('loader__logo--playing')
    this.logo.style.opacity = 0
    this.loaded = true

    const self = this
    TweenMax.delayedCall(0.5, () => {
      self.isHiding = true
      self.tlBgIn.play('out')
    })
  }
}
